/* eslint-disable @typescript-eslint/unbound-method */
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { timeEqualValidatorFn } from "shared-validators";

export const meetingRoomKioskBookingForm = () =>
  new FormGroup(
    {
      dateTimestamp: new FormControl<number | null>(null, Validators.required),
      startTime: new FormControl("", Validators.required),
      endTime: new FormControl("", Validators.required),
      title: new FormControl(""),
      // selectedUserId: new FormControl<string | null>(''),
      // selectedUser: new FormControl<IUser | null>(null),
      isPrivate: new FormControl<boolean>(false),
    },
    {
      validators: [timeEqualValidatorFn("startTime", "endTime")],
    },
  );

export type MeetingRoomKioskBookingForm = ReturnType<
  typeof meetingRoomKioskBookingForm
>;
